import { render, staticRenderFns } from "./SubCardInfo.vue?vue&type=template&id=23111a59&"
import script from "./SubCardInfo.vue?vue&type=script&lang=js&"
export * from "./SubCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports